import { render, staticRenderFns } from "./factory-tab.vue?vue&type=template&id=78fdbe36"
import script from "./factory-tab.vue?vue&type=script&lang=js"
export * from "./factory-tab.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports